import scopeUtils from "../../../utils/scope";
import CommonConstants from "../../../utils/CommonConstants";

export default class StoreAdminCartController {
    static $controllerName = 'Cartonomy.Cart.StoreAdminCartController';
    static $inject = [
        '$scope', 'CartService', '$state', '$rootScope', 'Session'
    ];

    constructor(scope, CartService, $state, $rootScope, sessionService) {
        this._scope = scope;
        this._sessionService = sessionService;
        this._cartService = CartService;
        this._stateService = $state;
        this._rootScope = $rootScope;
        this.carts = [];

        scope.overlayOpened = false;
        scope.model = this;

        scope.backToProfile = () => {
            if (this._sessionService.getStealthUserMode()) {
                this._sessionService.setStealthUserMode(null);
                this._cartService.resetCart();
                this._rootScope.$broadcast(CommonConstants.Events.ORDER_CANCELLED);
            }

            this._stateService.go(CommonConstants.RoutingStates.USER_PROFILE);
        };
        scope.goToCart = (cartId) => this.goToCart(cartId);
        scope.joinToCart = (cartId, cartToken) => this.joinToCart(cartId, cartToken)
    }

    async $onInit() {
        let carts = {};

        if(this._stateService.current.name === CommonConstants.RoutingStates.OPEN_CARTS)
        {
            this._rootScope.storeWindowTitle = 'client.carts';
            carts = await this._cartService.getCartReport("OPEN");
        }
        else
        {
            this._rootScope.storeWindowTitle = 'client.order.group_report';
            carts = await this._cartService.getCartReport();
        }

        scopeUtils.apply(this._scope, () => {
            this.carts = carts;
        });
    }

    async goToCart(cartId) {
        this._cartService.resetCartInvitationType();
        let currentUserEmail = await this._sessionService.getUserEmail();
        this._sessionService.setCartReference(null, false);
        let _cart = await this._cartService.getCartById(cartId);
        let isOwnerOrParticipant = false;
        const statuses = ['OWNER', 'JOINED'];
        if (_cart.participants && _cart.participants.length > 0) {
            isOwnerOrParticipant = _cart.participants.some(c => c.email === currentUserEmail && statuses.indexOf(c.status) > -1);
        }

        if (!isOwnerOrParticipant) {
            this._sessionService.setStealthUserMode(true);
        } else {
            this._sessionService.setStealthUserMode(null);
            // make sure cart is loaded before going to chat;
            this._sessionService.setCartReference(null, false);
            await this._cartService.getCart(cartId)
        }

        this._stateService.go(CommonConstants.RoutingStates.CART);
    }

    // accept cart [CW-2538]
    async joinToCart(cartId, cartToken) {
        this._cartService.shareTokenPromise = null;

        const response = await this._cartService.acceptInvite(cartToken, true);

        this._sessionService.setStealthUserMode(null);
        
        await this._cartService.getCart(cartId, false);

        this._stateService.go(CommonConstants.RoutingStates.CART);
    }
}



// WEBPACK FOOTER //
// ./src/modules/cart/controllers/StoreAdminCartController.js